// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2ps4g","modalTitle":"_10R70","checkboxWording":"_1KwaK"};